<template>
    <b-field expanded v-if="hasFieldSelect">
        <b-select
            v-model="model"
            @input="input(model)"
            expanded>
            <option
                v-for="type in types"
                :key="type.value"
                :value="type.value">
                {{ type.name }}
            </option>
        </b-select>
    </b-field>
    <b-field expanded v-else-if="name == 'student_enrollment_year'">
        <b-input
            v-model="model"
            @input="input(model)"
            type="number"
            step="1"
            required
        ></b-input>
    </b-field>
    <b-field expanded v-else-if="name == 'department_id'">
        <model-autocomplete
            field="name"
            endpoint="/api/departments"
            :params="{
                academic: true,
            }"
            :value="autocompleteModel"
            @clear="input(null)"
            @select="item => input(item.id)">
        </model-autocomplete>
    </b-field>
    <b-field expanded v-else-if="name == 'groups'">
        <b-select
            v-model="model"
            @input="input(model)"
            expanded>
            <option
                v-for="group in groups"
                :key="group.id"
                :value="group.id">
                {{ group.title }}
            </option>
        </b-select>
    </b-field>
    <b-field expanded v-else>
        {{ name }}
        <br>
        {{ rule }}
    </b-field>
</template>

<script>
import HasUser from "../../../mixins/HasUser";

export default Vue.extend({
  mixins: [HasUser],
  props: {
    value: {
      //
    },
    name: {
      type: String,
      required: true
    },
    rule: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      model: this.value,
      autocompleteModel: ""
    };
  },
  computed: {
    hasFieldSelect() {
      return ["student_type", "subject_type"].includes(this.name);
    },
    groups() {
      if (this.name != "groups") {
        return [];
      }

      return _.reject(
        _.pick(this.userPreset.profile, [
          "regular_group",
          "primary_language_group",
          "secondary_language_group",
          "graduate_group",
          "master_group",
          "bachelor_group"
        ]),
        _.isNull
      );
    },
    types() {
      if (!this.hasFieldSelect) {
        return;
      }

      let rules = this.rule.split("|");
      let rule = _.find(rules, rule => {
        if (_.startsWith(rule, "in:")) {
          return true;
        }
      });

      if (rule != undefined) {
        let types = _.trimStart(rule, "in:").split(",");

        return _.map(types, type => {
          let name;

          switch (this.name) {
            case "student_type": {
              name = this.$t(`students.type.${type}`);
              break;
            }
            case "subject_type": {
              name = this.$t(`roles.scopes.subject_type.type.${type}`);
              break;
            }
          }

          return {
            value: type,
            name
          };
        });
      }

      return [];
    }
  },
  created() {
    switch (this.name) {
      case "student_type":
      case "subject_type": {
        this.model = this.model || _.first(this.types).value;
        this.input(this.model);
        break;
      }
      case "student_enrollment_year": {
        this.model = this.model || this.$moment().year();
        this.input(this.model);
        break;
      }
      case "department_id": {
        if (this.model) {
          this.$helpers
            .load(axios.get(`/api/departments/${this.model}`))
            .then(({ data }) => {
              this.autocompleteModel = data.name;
            })
            .catch(error => {
              this.toast("error", "@unexpected", error);
            });
        }
        break;
      }
      case "groups": {
        this.model = this.model || _.first(this.groups).id;
        this.input(this.model);
        break;
      }
    }
  },
  methods: {
    input(value) {
      switch (this.name) {
        case "student_enrollment_year": {
          value = parseInt(value);
          break;
        }
      }

      this.$emit("input", value);
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/modals/roles/ScopeField.vue